import { createFileRoute, Navigate } from '@tanstack/react-router'
import { DetailPage } from '@navigator/EntityPage/screens/DetailPage'
import { z } from 'zod'
import { zodValidator } from '@tanstack/zod-adapter'
import { EntityQueries } from '@navigator/data'

export const Route = createFileRoute('/_auth/entity/$entityId/_breadcrumbs/details')({
  component: RouteComponent,
  validateSearch: zodValidator(
    z.object({
      view: z.union([z.number(), z.literal('advanced')]).optional(),
      utm_source: z.enum(['breadcrumb']).optional(),
    }),
  ),
  loader: async ({ context: { queryClient, effectiveUser, entity } }) => {
    const views = await queryClient.ensureQueryData(
      EntityQueries.detailsViews(entity.entityTypeId, effectiveUser?.orgId),
    )
    return { views }
  },
})

function RouteComponent() {
  const { entity, entityType } = Route.useRouteContext()
  const { views } = Route.useLoaderData()
  const { view } = Route.useSearch()

  if (!view) {
    const defaultView = views.find((v) => v.defaultInd)
    return (
      <Navigate
        from={Route.fullPath}
        search={(prev) => ({ ...prev, view: defaultView?.filterId ?? 'advanced' })}
        replace
      />
    )
  }

  return <DetailPage entity={entity} entityType={entityType} />
}
